import 'app.css';
import 'devexpress-reporting/dx-webdocumentviewer';
import ko from 'knockout';
import React from 'react';
import deMessages from 'devextreme/localization/messages/de.json';
import { locale, loadMessages } from 'devextreme/localization';

// Report URL configuration mapping
const reportUrlConfigs: Record<string, string> = {
	promenade: 'https://menuxreporting-promenade.menux.asia/',
	'promenade-staging': 'https://menuxreporting-promenade-uat.menux.asia/',
	imperial: 'https://menuxreporting-imperial.menux.asia/',
	'imperial-staging': 'https://menuxreporting-imperial-uat.menux.asia/',
	dev: 'https://menuxdevreporting.ifca.asia/',
	local: 'https://menuxdevreporting.ifca.asia/',
	uat: 'https://menuxuatreporting.ifca.asia/',
	swan: 'https://swan-menuxreporting.menux.asia/',
	swanuat: 'https://swan-menuxreporting-uat.menux.asia/',
	edu: 'https://menuxreporting-edu.menux.asia/',
	prod: 'https://menuxreporting.menux.asia/',
	pkns: 'https://pos-reporting.menux.asia/',
	'pkns-uat': 'https://pos-uat-reporting.menux.asia/',
	outlet1: 'https://menuxreporting.menux.asia/',
	outlet2: 'https://menuxreporting.menux.asia/',
	outlet3: 'https://menuxreporting.menux.asia/',
};

// Default report URL (production)
const defaultReportUrl = 'https://menuxreporting.menux.asia/';

// Get report URL based on environment
// Supports runtime configuration (window.__APP_ENV__) for "build once, deploy to multiple environments"
// Falls back to build-time configuration (process.env.REACT_APP_ENV) for development
const getReportUrl = (): string => {
	// Priority 1: Runtime configuration (for production deployments)
	// Priority 2: Build-time environment variable (for development)
	const env =
		process.env.REACT_APP_ENV ||
		(typeof window !== 'undefined' && window.__APP_ENV__);

	if (env && env in reportUrlConfigs) {
		return reportUrlConfigs[env];
	}

	return defaultReportUrl;
};

export const menuxReportUrl = getReportUrl();

var docURL: any = '',
	docHost: any = '',
	docExportFormat: any = [];

class RenderReportViewer extends React.Component {
	reportUrl: ko.Observable<any>;
	previewModel: ko.Observable<any>;
	requestOptions: {
		host: string;
		invokeAction: string;
	};
	callbacks: any | any;
	viewer: any;
	refs: any;

	constructor(props) {
		super(props);

		loadMessages(deMessages);
		locale('en-AU');

		this.reportUrl = ko.observable();
		this.previewModel = ko.observable();
		this.requestOptions = {
			host: docHost,
			invokeAction: '/WebDocumentViewer/Invoke',
		};

		this.previewModel.subscribe(function(newModel) {
			if (newModel) newModel.reportPreview.zoom(-1);
		});

		this.callbacks = {
			CustomizeParameterEditors: function(s, e) {
				if (e.parameter.type === 'System.DateTime') {
					e.info.editor = e.info.editor;
					e.info.editor.extendedOptions =
						(e.info.editor.extendedOptions || {},
						{
							type: 'date',
							displayFormat: 'dd/MM/yyyy',
							useMaskBehavior: true,
						});
				}
			},
		};

		if (docExportFormat.length > 0) {
			this.callbacks = {
				CustomizeExportOptions: function(s, e) {
					docExportFormat.forEach(doc => {
						e.HideFormat(doc);
					});
				},
			};
		}
	}

	getReport() {
		this.previewModel().OpenReport(docURL);
	}

	render() {
		return (
			<div>
				<div>
					<div
						ref="viewer"
						data-bind="dxReportViewer: $data"
						style={{ width: '100%', height: '900px' }}
					></div>
				</div>
			</div>
		);
	}
	componentDidMount() {
		ko.applyBindings(
			{
				reportUrl: this.reportUrl,
				viewerModel: this.previewModel,
				requestOptions: this.requestOptions,
				callbacks: this.callbacks,
			},
			this.refs.viewer,
		);

		this.getReport();
	}
	componentWillUnmount() {
		ko.cleanNode(this.refs.viewer);
	}
}

function ReportViewer(props: any) {
	docURL = props.url;
	docHost = props.host;
	docExportFormat = props.excludedExportFormat;
	return (
		<>
			<RenderReportViewer />
		</>
	);
}

export default ReportViewer;
